import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Tooltip } from "@progress/kendo-react-tooltip";
import { setExpanded, setFocusedElement } from "../../../../../actions/userProfileSidebar";
import "../../../../../components/Tasks/tasks.scss";
import { number } from "../../../../../config";
import { userProfileNavbarOptions } from "./userProfileSidebar.constants";

/**
 * UserProfileSidebarQuickActions component handles quick action button logic
 * @author Bhavana
 */
const UserProfileSidebarQuickActions = () => {
  const [focusedElementId, setFocusedElementId] = useState(null);
  const dispatch = useDispatch();
  const { expanded } = useSelector((state) => state.userProfileSidebar || { expanded: [] });

  /**
   * Opens content sections by clicking quick action buttons
   * @param {Object} element - The navbar option element
   * @returns {void}
   * @author Bhavana
   */
  const handleQuickActionButton = async (element) => {
    setFocusedElementId(element.id);
    if (element?.id !== "profile-personal-info" && !expanded.includes(element?.id)) {
      await dispatch(setExpanded([...expanded, element?.id]));
    }
    const elmnt = document.getElementById(element.id);
    if (elmnt) {
      setTimeout(() => {
        elmnt.scrollIntoView({ behavior: "smooth", block: "start" });
      }, number.SIX_HUNDRED || 100);
    }
  };

  return (
    <>
      <Tooltip anchorElement='target' position='left' parentTitle='true'>
        {userProfileNavbarOptions.map((element) => {
          const disabled = element.disableCondition();
          const elementLabel = element.label instanceof Function ? element.label() : element.label;
          const elementIcon = element.icon instanceof Function ? element.icon() : element.icon;
          const show = element.renderCondition ? element.renderCondition(element.render) : true;
          if (!show) {
            return null;
          }
          return (
            <button
              title={elementLabel}
              className={`cursor-pointer tooltip-text position-relative d-inline-block action-icons sidebar-action-buttons-color border-0 bg-transparent mb-1 d-flex align-items-center justify-content-center ${
                focusedElementId === element.id ? "active-quick-actions" : ""
              }`}
              key={element.id}
              disabled={disabled}
              onClick={() => handleQuickActionButton(element)}>
              {elementIcon}
            </button>
          );
        })}
      </Tooltip>
    </>
  );
};

export default UserProfileSidebarQuickActions;